import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/components/mdx/index.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`📱 Native`}</h2>
    <ul>
      <li parentName="ul">{`Guidelines for Motion and Loaders are in the works. (Tom G.)`}</li>
      <li parentName="ul">{`We’ve kicked off work on the Dropdown, Toggle Chip, Filter Chip, Pill, Banner, and Toast components for Android as well as Banner and Toast components for iOS.`}</li>
      <li parentName="ul">{`The Calendar component for iOS has shipped. (Dan R.)`}</li>
      <li parentName="ul">{`The Filter Chip for iOS is in code review. (Andrew W.)`}</li>
      <li parentName="ul">{`We’ve shipped a Tokens for Android documentation page. We’ll be working with Android engineers to get those tokens adopted on our Android codebase. (Daniel O.)`}</li>
    </ul>
    <h2>{`🍭 Design`}</h2>
    <ul>
      <li parentName="ul">{`Color palette tweaks are coming soon, improving accessibility across the product. (Jon K.)`}</li>
      <li parentName="ul">{`New android headers are being designed. (Jon K.)`}</li>
      <li parentName="ul">{`Android layouts will be shipping to Figma soon. (Jon K.)`}</li>
    </ul>
    <h2>{`🖥 Web`}</h2>
    <ul>
      <li parentName="ul">{`We’ve `}<a parentName="li" {...{
          "href": "https://github.com/thumbtack/thumbprint/issues/544"
        }}>{`moved a few components and CSS classes`}</a>{` out of Thumbprint. Thumbtack’s website has already been updated to support this breaking change.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      